module.exports = __webpack_public_path__ + "img/marker-nodisc-green.572885ec.png";